import type { BaseItemContent } from "./content";
import type { BaseItemSchema } from "./item";
import type { SessionType } from "./types";

export interface SessionItem extends BaseItemSchema {
	stimulus?: BaseItemContent;
	items?: BaseItemSchema[];
}

export type BlockedSessionItems = SessionItem[][];

export type BackendSessionResponse = {
	id: number;
	numericId: number;
	collectionId: number;
	sessionItems: SessionItem[];
	errors?: {
		title: string;
		message: string;
	};
	examName: string;
	startTime: string;
	sessionType: SessionType;
	totalTime: number;
	status: "ACTIVE" | "COMPLETE" | "NOT_STARTED";
};

export type ExamBreak = {
	startTime: string;
	endTime: string;
	totalBreakTimeTakenInSeconds?: number;
	status: "STARTED" | "EXPIRED";
	allotedTime: number;
	section: string;
};

export type SessionResponse = {
	id: number;
	numericId: number;
	collectionId: number;
	sessionItems: BaseItemSchema[][];
	startTime?: string;
	totalTime?: number;
	examBreak?: ExamBreak[];
	examName?: string;
	sessionTime?: number;
	sessionSubType?: "DIAGNOSTIC" | "PRACTICE_TEST";
	sessionType?: SessionType;
};
